import { css } from '@emotion/css';
import { Grid, Select } from '@material-ui/core';
import { Tab, Tabs } from '@material-ui/core';
import {
  getInfosBusiness,
  getInfosDashboard,
  getVitrineField,
} from '@webapps/business';
import { useAuth, useQuery, useRouter } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';

import EditMedia from 'components/Media/Edit/EditMedia';
import { useState } from 'react';

import Presentation from './Components/presentation';
import ProfilName from './Components/profilName';

const EditVitrineBusiness = () => {
  const { classes, global, cx } = useStyles(styles);
  const { params } = useRouter();
  const { id: idParam } = params;
  const { idUser, profile } = useAuth();

  const { data: fieldVitrine = {} } = useQuery(getVitrineField, {
    key: 'businessFieldVitrine',
    variables: { id: idParam ?? idUser },
    keepPreviousData: true,
  });

  const { data: infosVitrine = {}, refetch: refetchInfo, isLoading } = useQuery(
    getInfosBusiness,
    {
      key: 'businessInfosVitrine',
      variables: { id: typeof idParam !== 'undefined' ? idParam : idUser },
      keepPreviousData: true,
    }
  );

  const { data: dashboardInfo = {}, refetch: refetchDashboardInfo } = useQuery(
    getInfosDashboard,
    {
      key: 'infoDashboardBusiness',
      variables: { id: typeof idParam !== 'undefined' ? idParam : idUser },
      keepPreviousData: true,
    }
  );

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [value, setValue] = useState(0);

  return (
    <div className={cx(global.container, classes.container)}>
      <Grid container className={classes.responsiveContainer}>
        <Grid
          item
          xs={12}
          md={12}
          lg={4}
          className={css({ '@media (max-width:768px)': { width: '100%' } })}
        >
          <ProfilName
            city={infosVitrine?.address?.city}
            coverImage={dashboardInfo?.profile?.coverImageUrl}
            cp={infosVitrine?.address?.cityCode}
            name={infosVitrine?.name}
            slogan={fieldVitrine?.data?.slogan}
            profileImage={dashboardInfo?.profile?.profileImageUrl}
            refetch={refetchDashboardInfo}
            verified={dashboardInfo?.profile?.verified}
            website={infosVitrine?.website}
          />
        </Grid>
        <Grid item xs container direction="column">
          <Grid item className={css({ '@media (max-width:1280px)': { marginTop: 50 }, '@media (max-width:768px)': { marginTop: 20 } })}>
            <Tabs
              value={value}
              variant="fullWidth"
              indicatorColor="none"
              TabIndicatorProps={{
                display: 'none',
              }}
              onChange={handleChange}
            >
              <Tab
                label="A propos"
                style={{
                  border: '1px solid #C0D9FF',
                  borderBottom: 0,
                  borderTopLeftRadius: 5,
                  borderTopRightRadius: 5,
                  opacity: 1,
                  backgroundColor: value === 0 ? 'white' : '#F3F7FF',
                  color: value === 0 ? '#152652' : '#5A6DA1',
                  fontWeight: value === 0 ? 600 : 400,
                  fontFamily: 'Montserrat',
                }}
                className={global.mainTitle}
              />
              <Tab
                label="Médias"
                style={{
                  border: '1px solid #C0D9FF',
                  borderBottom: 0,
                  borderTopLeftRadius: 5,
                  borderTopRightRadius: 5,
                  opacity: 1,
                  backgroundColor: value === 1 ? 'white' : '#F3F7FF',
                  color: value === 1 ? '#152652' : '#5A6DA1',
                  fontWeight: value === 1 ? 600 : 400,
                  fontFamily: 'Montserrat',
                }}
                className={global.mainTitle}
              />
            </Tabs>
            <TabPanel value={value} index={0}>
              <Presentation
                infosVitrine={infosVitrine}
                presentation={dashboardInfo?.profile?.presentation}
                goodtoknow={fieldVitrine?.data?.goodtoknow}
                whattheyseek={fieldVitrine?.data?.whattheyseek}
                refetch={refetchInfo}
                isLoading={isLoading}
                description={dashboardInfo?.profile?.presentation}
                item
              />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <EditMedia />
            </TabPanel>
          </Grid>
          {/* <Grid item xs={12}>
          <Offer />
        </Grid>
        <Grid item xs={12}>
          <Partner />
        </Grid> */}
        </Grid>
      </Grid>
    </div>
  );
};

const styles = ({ spacing }) => ({
  responsiveContainer: {
    columnGap: '30px',
    '@media only screen and (max-width: 768px)': {
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      rowGap: '20px',
    },
  },
  container: {
    fontWeight: 400,
    color: '#5D75A8',
    width: '100%',
    '@media (max-width:768px)': { padding: '20px' },
    '@media (max-width:1020px)': {
      overflow: 'visible',
    },
  },
});

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Grid item sx={{ p: 0 }}>
          {children}
        </Grid>
      )}
    </div>
  );
}

export default EditVitrineBusiness;
